import gql from 'graphql-tag';

export const TOGGLE_RECORDING = gql`
	mutation ToggleRecording($input: ToggleRecordingInput!) {
		toggleRecording(input: $input)
	}
`;
